exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block__inner[data-v-662e6adc] {\n  text-align: center;\n  font-weight: 400;\n}\n.page-block[data-v-662e6adc]{\n  padding: 10px 30px;\n  height: 73vh;\n}\n.title-font[data-v-662e6adc]{\n  font-size: 20px;\n}\n.subtitle[data-v-662e6adc] {\nmargin-top: 15px;\n  margin-bottom: 42px;\n}\n", ""]);

// exports
